import React from "react";
import Grid from "../../../../../atoms/Grid";
import { previewScheduleColumns } from "./previewScheduleColumns";
import { PaymentSchedule } from "./types";

type PreviewScheduleGridProps = {
  paymentSchedule: PaymentSchedule[];
};

export const PreviewScheduleGrid = (props: PreviewScheduleGridProps) => {
  const { paymentSchedule } = props;

  return <Grid fullPage className="p-0" columns={previewScheduleColumns} data={paymentSchedule} />;
};
